// = Icons =
import AcceptIcon from '@/common/components/icons/accept-icon';
import BriefcaseIcon from '@/common/components/icons/briefcase-icon';
import CalendarIcon from '@/common/components/icons/calendar-icon';
import DeleteIcon from '@/common/components/icons/delete-icon';
import DropdownIcon from '@/common/components/icons/dropdown-icon';
import FileIcon from '@/common/components/icons/file-icon';
import GlobeIcon from '@/common/components/icons/globe-icon';
import HelpIcon from '@/common/components/icons/help-icon';
import LocationIcon from '@/common/components/icons/location-icon';
import MenuIcon from '@/common/components/icons/menu-icon';
import PhoneIcon from '@/common/components/icons/phone-icon';
import PlusIcon from '@/common/components/icons/plus-icon';
import SearchIcon from '@/common/components/icons/search-icon';
import TimerIcon from '@/common/components/icons/timer-icon';
import WalletIcon from '@/common/components/icons/wallet-icon';
import StarIcon from '@/common/components/icons/star-icon';
import LeftArrowIcon from '@/common/components/icons/arrow-left-icon';
import RightArrowIcon from '@/common/components/icons/arrow-right-icon';
import AsteriskIcon from '@/common/components/icons/asterisk-icon';
import PdfIcon from '@/common/components/icons/pdf-icon';
import BasketIcon from '@/common/components/icons/basket-icon';
import WarningIcon from '@/common/components/icons/warning-icon';

// = Types =
import { ElementType } from 'react';
import { IconType } from '@/common/components/ui/icon/icon.types';

const ICONS: Record<IconType, ElementType> = {
  accept: AcceptIcon,
  'arrow-left': LeftArrowIcon,
  'arrow-right': RightArrowIcon,
  asterisk: AsteriskIcon,
  basket: BasketIcon,
  briefcase: BriefcaseIcon,
  calendar: CalendarIcon,
  delete: DeleteIcon,
  dropdown: DropdownIcon,
  file: FileIcon,
  globe: GlobeIcon,
  help: HelpIcon,
  location: LocationIcon,
  menu: MenuIcon,
  pdf: PdfIcon,
  phone: PhoneIcon,
  plus: PlusIcon,
  search: SearchIcon,
  timer: TimerIcon,
  wallet: WalletIcon,
  warning: WarningIcon,
  star: StarIcon,
};

export default ICONS;
